<template>
  <div class="login-bg color-grey">
    <div v-if="isDesktop">
      <img class="QRLogo" src="../assets/logo-white.png" alt="Logo" />
    </div>
    <div class="text-center">
      <form @submit.prevent="tryLogin">
        <!-- <h4 class="pt-3 pb-3">{{ $t('login.title') }}</h4> -->
        <div class="logo-container">
          <img
            :src="
              !linkMode
                ? '/icons/white-logo.png'
                : (cafe_image || '/icons/cafe-logo-placeholder.jpg')
            "
            :class="!linkMode ? 'mb-50 logo-large' : 'cafe-logo'"
            alt="logo"
          />
          <div class="logout" v-if="linkMode">
            <div class="logout-btn" @click="doLogout">{{ $t('navbar.logout') }}</div>
          </div>
        </div>
        <!-- <p v-if="!linkMode">{{ $t('login.enter_qid_pin') }}</p> -->
        <!-- <p v-if="linkMode">{{ $t('login.enter_pin') }}</p> -->
        <input
          type="text"
          :placeholder="$t('login.qid_ph')"
          :class="{
            qid: true,
            'input-red': error || qid_valid_state == 'invalid',
            'input-green': loginData.qId && qid_valid_state == 'valid',
          }"
          @blur="checkQid"
          name="qrwaiter_qId"
          v-model="loginData.qId"
          v-if="!linkMode"
        />
        <!-- <b v-if="linkMode">{{ loginData.qId }} <br></b> -->
        <input
          :class="error ? 'input-red' : ''"
          type="text"
          maxlength="4"
          :placeholder="$t('login.enter_pin')"
          :value="loginData.pin"
          readonly
          v-if="true"
        />
        <div class="pin" v-if="true">
          <button
            type="button"
            class="number n"
            v-for="i in 9"
            @click="enterNum(i)"
          >
            {{ i }}
          </button>
          <button type="button" class="number x" @click="pinBackspace"></button>
          <button type="button" class="number" @click="enterNum(0)">0</button>
          <button class="number ok" type="submit">ok</button>
        </div>
        <div v-if="false">
          <button class="login" type="submit">
            {{ $t("login.enter_shared") }}
          </button>
        </div>
      </form>
      <br />
    </div>
    <div v-if="isDesktop" class="support-link"><a href="https://t.me/QRWaiterSupportBot">Support</a></div>
  </div>
  <!-- <LoginDesktop v-else /> -->
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import LoginDesktop from "./LoginDesktop";

import AuthAPI from "@/api/auth";

import SharedQueueService from "@/services/shared";

import QueueAPI from "@/api/queue";

export default {
  data() {
    return {
      loginData: {
        qId: null,
        pin: "",
        captcha: null,
      },

      linkMode: false,
      error: null,

      qid_valid_state: null,

      cafe_image: null
    };
  },
  methods: {
    loginAsWaiter() {
      AuthAPI.loginAsWaiter(
        this.loginData.qId,
        this.loginData.pin,
        this.loginData.captcha
      )
        .then((data) => {
          SharedQueueService.clearStamp();
          this.$store.dispatch("init").then((ok) => {
            // console.log();
            this.$router.push({
              path: "/orders",
              query: {
                m: this.$route.query.m || undefined
              }
            });
          });
        })
        .catch((error) => {
          this.error = error;

          this.loginData.pin = "";
        });
    },
    loginIntoSharedQueue() {
      AuthAPI.loginShared(this.loginData.qId)
        .then((data) => {
          SharedQueueService.saveSharedStamp(data.sid);
          this.$router.push("/orders");
        })
        .catch((error) => {
          alert(error);
        });
    },
    tryLogin() {
      // if (!this.isDesktop) {
      //   this.loginAsWaiter();
      // } else {
      //   this.loginIntoSharedQueue();
      // }
      this.loginAsWaiter();
    },
    handleCaptchaResponse(data) {
      this.loginData.captcha = data;
    },
    enterNum(n) {
      this.error = null;
      if (this.loginData.pin.length >= 4) return;
      this.loginData.pin = this.loginData.pin + `${n}`;
    },
    pinBackspace() {
      if (this.loginData.pin.length == 0) return;

      this.loginData.pin = this.loginData.pin.substring(
        0,
        this.loginData.pin.length - 1
      );
    },
    checkLink() {
      if (this.$route.params.qid) {
        this.linkMode = true;
        this.loginData.qId = this.$route.params.qid;

        if (this.loginData.qId) {
          window.localStorage.setItem(`last_qid`, this.loginData.qId);
        }

        this.checkQid();

        if (this.$route.query.pin) {
          const real_pin = atob(this.$route.query.pin);

          this.loginData.pin = real_pin;

          this.loginAsWaiter();
        }
      }

      if (this.$route.query.from_new) {
        window.localStorage.setItem('no_new_version', 'true');
      }

      if (![
        '13C0-70F8-4A16',
        'A225-8C96-E2B6'
      ].includes(this.loginData.qId) && !this.isDesktop) {
        window.location.href = window.location.href.replace('queue.', 'pos.'); 
      }
    },
    checkQid() {
      QueueAPI.checkQid(this.loginData.qId)
        .then((data) => {
          if (data.valid) {
            this.qid_valid_state = "valid";
            this.cafe_image = data.cafe_image;
          } else {
            this.qid_valid_state = "invalid";
          }
        })
        .catch((error) => {
          this.qid_valid_state = "invalid";
        });
    },
    onKeyPressed(e) {
      if (
        (e.keyCode >= 48 && e.keyCode <= 57) ||
        (e.keyCode >= 96 && e.keyCode <= 105)
      ) {
        this.enterNum(+e.key);
        return;
      }

      if (e.keyCode == 13) {
        this.loginAsWaiter();
        return;
      }
    },
    doLogout() {
      this.$router.push('/login');
      this.linkMode = false;
      this.loginData.qId = '';
    }
  },

  mounted() {
    window.document.body.style.backgroundColor = "#1d1d1d";
    this.checkLink();

    window.addEventListener("keyup", this.onKeyPressed);
  },
  beforeDestroy() {
    window.document.body.style.backgroundColor = "#1d1d1d";

    window.removeEventListener("keyup", this.onKeyPressed);
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
  },
  components: {
    VueRecaptcha,
    LoginDesktop,
  },
};
</script>

<style scoped>
* {
  font-family: "Chadwick", Arial, Helvetica, sans-serif;
}
.logout {
  position: absolute;
  top: 0;
  left: 0;
  width: 92.9%;
  height: 100%;
  backdrop-filter: blur(5px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1;
  display: none;
  margin-left: 1.4vh;
  border-radius: 25px;
}
.logout-btn {
  z-index: 10;
  width: 15.444vh;
  height: 5.444vh;
  background: #e2223b;
  border-radius: 2.722vh;
  display: flex;
  font-size: 1.777vh;
  color: #ededed;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
}
.logo-container {
  position: relative;
}
.logo-container:hover div.logout {
  display: flex;
}
.cafe-logo {
  width: 72.667vw;
  height: 16.748768472906402vh;
  border-radius: 25px;
  object-fit: cover;
}
form {
  display: flex;
  flex-flow: column;
}

.mb-50 {
  margin-bottom: 5.5vh;
}

img.logo-small {
  height: 12.3vh;
  margin: 0 auto;
  width: auto;
}

.login-bg {
  height: 100vh;
  padding: 8.62vh 10.667vw 0;
  background: #1d1d1b;
}

.pin {
  padding: 3.333vh 0 0;
  width: 100%;
  display: grid;
  grid-template-rows: 11.4vh 11.4vh 11.4vh 11.4vh;
  grid-template-columns: 9.6vh 9.6vh 9.6vh;
  justify-content: space-around;
  touch-action: manipulation;
}

img.logo-large {
  height: 12.32vh;
  width: auto;
  margin: 2.216vh auto;
}
.logo-container {
  margin-bottom: 3.333vh;
}
input {
  text-align: center;
  padding: 1.4vh 0;
  color: white;
  width: 90.1%;
  border-radius: 35px;
  font-size: 4.267vw;
  background: transparent;
  outline: none;
  border: 2px solid #ededed;
  margin: 0 auto;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input.qid {
  margin-bottom: 1.6666666666666667vh;
  /* width: 100%; */
}

.number {
  background: #efeff4;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  align-self: auto;
  padding: 5px;
  margin: 0 0 1.8vh;
  border: 0;
  font-size: 4vh;
  transition: 0.3s;
  font-weight: 500;
  outline: none;
  touch-action: manipulation;
}

.number.ok {
  background: #129b81;
  color: white;
  font-size: 4.4vh;
  border: 0;
  padding: 0;
}
.logo-large {
  width: 11.111vh;
  height: 11.111vh;
}
.number.x {
  box-shadow: none;
  border-radius: 0;
  background: #1d1d1d;
  background-image: url("/../icons/cancel-btn.svg");
  background-repeat: no-repeat;
  background-size: contain;
}

.number.x img {
  height: 9.5vh;
  width: auto;
  margin-left: -0.5vh;
  display: block;
}

button.login {
  background: #129b81;
  outline: none;
  padding: 1.6vh 0;
  width: 80vw;
  border-radius: 10vh;
  margin-top: 3.7vh;
  border: none;
  color: white;
}

.number.n:active,
.number.n:hover {
  background-color: #757575;
  color: #ffffff;
}

.input-red {
  border: 2px solid #e2223b !important;
}

.input-green {
  border: 2px solid #129b81 !important;
}

@media (min-width: 769px) {
  .number.ok {
    font-size: 2.5vw;
  }
  .QRLogo {
    width: 2.083vw;
    height: 2.083vw;
    position: absolute;
    top: 1.597vw;
    left: 3.472vw;
    margin: 0;
  }

  .support-link a {
    position: absolute;
    left: 3.472vw;
    bottom: 2.639vw;
    font-weight: 500;
    font-size: 2.014vw;
    line-height: 2.292vw;
    color: #cbd9e6;
    text-decoration: none;
  }
  img.cafe-logo {
    width: 18.486vw;
    height: 9.444vw;
  }
  .logo-container {
    margin-bottom: 2.083vw;
  }
  .login-bg {
    padding: 0 0 0;
    display: flex;
    justify-content: center;
  }
  form input {
    width: 18.686vw;
    height: 3.403vw;
    font-size: 1.111vw;
    margin-top: 0;
  }
  button.number {
    width: 5.417vw;
    height: 5.417vw;
    font-size: 2.5vw;
    margin-bottom: 1.042vw;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  button.number:nth-last-child(-n + 3) {
    margin-bottom: 0;
  }
  div.pin {
    padding: 0;
    margin-top: 2.083vw;
    display: flex;
    flex-wrap: wrap;
    width: 20.486vw;
  }
  input.qid {
    margin-bottom: 1.041vw;
    width: 18.686vw;
  }
  div.text-center {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
